const mimeTypeToExtension: Record<string, string> = {
  'text/csv': '.csv',
  'application/pdf': '.pdf',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
  'application/vnd.ms-excel': '.xls',
  'application/zip': '.zip',
  // Add more MIME types and their extensions as needed
}

export const downloadFile = (
  data: BlobPart,
  filename?: string,
  mimeType: string = 'text/csv',
) => {
  // Determine the file extension from MIME type
  const extension = mimeTypeToExtension[mimeType] || '.txt'

  // If filename is provided, use it; otherwise, default to 'download' with the correct extension
  const finalFilename = filename?.endsWith(extension)
    ? filename
    : `${filename || 'download'}${extension}`

  const blob = new Blob([data], { type: mimeType })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = finalFilename
  link.click()
  window.URL.revokeObjectURL(url) //Cleanup
}
